module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0110.png.1d56d963.jpg";